import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-scroll';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from '../../locale/messages';
import history from '../../core/history';

// 🔥 SAFE IMPORT — never fails
import * as Icons from '../../components/Common/Assets/SvgComponent/commonSvgIcon';
const DoubleArrowIcon = Icons.DoubleArrowIcon || Icons.default;

import s from './WhyHostBanner.css';
import bt from '../../components/commonStyle.css';

const WhyHostBanner = ({ data }) => {

    const isAuthenticated = useSelector(state => state.runtime.isAuthenticated);

    const handleClick = () => {
        if (isAuthenticated) {
            history.push('/become-a-host?mode=new');
        } else {
            history.push('/login?refer=/become-a-host?mode=new');
        }
    };

    return (
        <div className={cx(s.grid, 'commonWordBreak')}>
            <div className={s.bannerText}>
                <h1 className={s.bannerTitle}>{data?.hostBannerTitle1}</h1>

                <div className={cx(s.whyHostBtnFlex)}>
                    <Button className={cx(bt.btnPrimary, s.borderRadius)} onClick={handleClick}>
                        <FormattedMessage {...messages.becomeAHost} />
                    </Button>

                    <Link
                        className={cx(bt.btnPrimaryBorder, s.borderRadius, s.whyHostLearnMoreBtn)}
                        to="whyhost-sections"
                        smooth={true}
                        duration={500}
                        offset={-20}
                        spy={false}
                    >
                        <FormattedMessage {...messages.learnMore} />
                        <DoubleArrowIcon className={s.learnIcon} />
                    </Link>
                </div>
            </div>

            <div
                className={s.TopBannerHeader}
                style={{
                    backgroundImage: `url(/images/home/${data?.hostBannerImage1})`
                }}
            />
        </div>
    );
};

export default withStyles(s, bt)(WhyHostBanner);
